import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { Text } from '@telegram-apps/telegram-ui';
import { ListGoal } from '../../client/types';
import { useFeatureFlag } from '../../contexts/FeatureFlagContext';
import { CommonIcon } from './CommonIcon';

export type LevelProgressProps = {
  goal: ListGoal;
};

export const LevelProgress = ({ goal }: LevelProgressProps) => {
  const rewardsEnabled = useFeatureFlag('rewards');
  const segmentSizes = [
    goal.l1Target,
    Math.max(goal.l2Target - goal.l1Target, 0),
    Math.max(goal.l3Target - goal.l2Target, 0),
  ];
  const rewardValues = [goal.l1CurrencyReward, goal.l2CurrencyReward, goal.l3CurrencyReward];
  const segments = segmentSizes.map((size, idx) => {
    const prevSum = segmentSizes.slice(0, idx).reduce((sum, v) => sum + v, 0);
    const done = Math.min(Math.max(goal.completedXP - prevSum, 0), size);
    const percent = size > 0 ? Math.round((done / size) * 100) : 0;
    return percent;
  });

  return (
    <Box display="flex" width="100%">
      {segments.map((percent, idx) => (
        <Box key={idx} display="flex" flexDirection="column" alignItems="center" flex={1}>
          <Box display="flex" alignItems="center" width="100%">
            <LinearProgress
              variant="determinate"
              value={percent}
              sx={{
                flex: 1,
                height: 16,
                background: goal.targetLevel && idx >= goal.targetLevel 
                    ? `repeating-linear-gradient(-45deg, var(--tgui--hint_color), var(--tgui--hint_color) 5px, color-mix(in srgb, var(--tgui--hint_color), var(--tgui--text_color) 70%) 5px, color-mix(in srgb, var(--tgui--hint_color), var(--tgui--text_color) 70%) 10px)` 
                    : 'var(--tgui--hint_color)',
                borderRadius:
                  idx === 0
                    ? '8px 0 0 8px'
                    : idx === segments.length - 1
                    ? '0 8px 8px 0'
                    : 0,
                '& .MuiLinearProgress-bar': {
                  borderRadius:
                    idx === 0
                      ? '8px 0 0 8px'
                      : idx === segments.length - 1
                      ? '0 8px 8px 0'
                      : 0,
                  background: goal.targetLevel && idx >= goal.targetLevel 
                    ? `repeating-linear-gradient(-45deg, var(--tgui--button_color), var(--tgui--button_color) 5px, color-mix(in srgb, var(--tgui--button_color), var(--tgui--text_color) 30%) 5px, color-mix(in srgb, var(--tgui--button_color), var(--tgui--text_color) 30%) 10px)` 
                    : 'var(--tgui--button_color)',
                },
              }}
            />
            <CommonIcon
              icon={rewardsEnabled ? "paid" : "flag"}
              type="filled"
              size={36}
              color={percent === 100 ? 'var(--tgui--button_color)' : 'var(--tgui--hint_color)'}
            />
          </Box>
          {rewardsEnabled &&
            <Text weight="1" style={{ alignSelf: 'flex-end', color: percent === 100 ? 'var(--tgui--button_color)' : 'var(--tgui--hint_color)', marginRight: idx < 2 ? '8px' : '3px' }}>
              {rewardValues[idx]}
            </Text>
          }
        </Box>
      ))}
    </Box>
  );
}; 